import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import arrayEntry from '../fragments/arrayEntry.js';
import department from './department.js';
var schema = defineObject('internationalizedArrayDepartmentsValue', {
    value: {
        title: 'Value',
        type: 'array',
        of: [
            {
                type: 'department'
            }
        ]
    }
}, [
    department.schema.department
]);
var validator = z.object({
    value: z.array(department.validator.merge(arrayEntry.validator))
}).partial();
schema.internationalizedArrayDepartmentsValue;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayDepartmentsValue.js.map